import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface QRScannerProps {
  onScan: (secret: string, name: string) => void;
  onClose: () => void;
}

const QRScanner: React.FC<QRScannerProps> = ({ onScan, onClose }) => {
  const { t } = useTranslation();
  const [qrData, setQrData] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleQRInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setQrData(e.target.value);
  };

  const handleSubmit = () => {
    try {
      // Parse otpauth URL format: otpauth://totp/name?secret=SECRET&issuer=ISSUER
      const url = new URL(qrData);
      if (url.protocol !== 'otpauth:') {
        throw new Error(t('invalid_qr_format'));
      }
      
      const secret = url.searchParams.get('secret');
      const name = url.pathname.split('/').pop() || '';
      
      if (!secret) {
        throw new Error(t('no_secret_found'));
      }
      
      onScan(secret, decodeURIComponent(name));
      onClose();
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'white', padding: 24, borderRadius: 8, maxWidth: 400 }}>
        <h3>{t('scan_qr')}</h3>
        <textarea
          placeholder={t('paste_qr_data')}
          value={qrData}
          onChange={handleQRInput}
          rows={4}
          style={{ width: '100%', marginBottom: 16 }}
        />
        {error && <div style={{ color: 'red', marginBottom: 16 }}>{error}</div>}
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={handleSubmit}>{t('scan')}</button>
          <button onClick={onClose}>{t('cancel')}</button>
        </div>
      </div>
    </div>
  );
};

export default QRScanner; 